"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _RelativeDurationFormats = _interopRequireDefault(require("../constants/RelativeDurationFormats"));

var _default = function _default(duration, options) {
  var format = options && options.format || _RelativeDurationFormats.default.MEDIUM;
  var combined = options && options.combined;
  var seconds = Math.round(duration.asSeconds());

  if (seconds < 60) {
    var secondsAmount = {
      seconds: seconds > 0 ? seconds : 1
    };

    if (format === _RelativeDurationFormats.default.SHORT) {
      return _I18n.default.text('i18n.duration.shortForm.seconds', secondsAmount);
    }

    return _I18n.default.text('i18n.duration.seconds', secondsAmount);
  }

  var minutes = Math.round(duration.asMinutes());

  if (minutes < 60) {
    if (format === _RelativeDurationFormats.default.SHORT) {
      return _I18n.default.text('i18n.duration.shortForm.minutes', {
        minutes: minutes
      });
    }

    return _I18n.default.text('i18n.duration.minutes', {
      minutes: minutes
    });
  }

  var hours = Math.round(duration.asHours());

  if (hours < 24) {
    if (combined) {
      var flooredHours = Math.floor(duration.asHours());
      var flooredMins = Math.floor(duration.asMinutes());

      if (flooredMins % 60 > 0) {
        if (format === _RelativeDurationFormats.default.SHORT) {
          return _I18n.default.text('i18n.duration.shortForm.hoursAndMinutes', {
            hours: flooredHours,
            minutes: flooredMins % 60
          });
        } else {
          return _I18n.default.text('i18n.duration.hoursAndMinutes', {
            hours: flooredHours,
            minutes: flooredMins % 60
          });
        }
      }
    }

    if (format === _RelativeDurationFormats.default.SHORT) {
      return _I18n.default.text('i18n.duration.shortForm.hours', {
        hours: hours
      });
    }

    return _I18n.default.text('i18n.duration.hours', {
      hours: hours
    });
  }

  var days = Math.round(duration.asDays());

  if (format === _RelativeDurationFormats.default.SHORT) {
    return _I18n.default.text('i18n.duration.shortForm.days', {
      days: days
    });
  }

  return _I18n.default.text('i18n.duration.days', {
    days: days
  });
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/utils/formatRelativeDuration.js
// module id = 874
// module chunks = 209 210 211 212